/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Trial_LabelInputs */

const en_fc_cmp_trial_label = /** @type {(inputs: Fc_Cmp_Trial_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial`)
};

/**
* | output |
* | --- |
* | "Trial" |
*
* @param {Fc_Cmp_Trial_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_trial_label = /** @type {((inputs?: Fc_Cmp_Trial_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Trial_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_trial_label(inputs)
});
export { fc_cmp_trial_label as "fc.cmp.trial.label" }